import { render, staticRenderFns } from "./CommonDStatement.vue?vue&type=template&id=6a89669a&scoped=true"
import script from "./CommonDStatement.vue?vue&type=script&lang=js"
export * from "./CommonDStatement.vue?vue&type=script&lang=js"
import style0 from "./CommonDStatement.vue?vue&type=style&index=0&id=6a89669a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a89669a",
  null
  
)

export default component.exports